export class ChunkUploadDto {
  sessionId: string | null;
  totalNumberOfParts: number;
  partNumber: number;
  jsonData: string;

  constructor(totalNumberOfParts: number, partNumber: number, jsonData: string, sessionId: string | null = null) {
    this.sessionId = sessionId;
    this.totalNumberOfParts = totalNumberOfParts;
    this.partNumber = partNumber;
    this.jsonData = jsonData;
  }
}
